import { FormFields } from '@epi-forms/helpers';

export const getOther = (name: string) => `${FormFields.Other}.${name}`;
